import React from 'react';
import { store } from '../../store'

import connectWithStore from '../../utils/store'

import { fetchTilbodMulti, deleteTilbod } from '../../api/offers/actions';
import moment from 'moment'
import { formatKennitala, getInitials, allInsuranceTakersHaveId } from '../../utils';
import { SvgCheckIcon, SvgCloseIcon } from '../svg';
import { offerTypesForBeneficiaries } from '../../constants';

const AGENT_THRESHOLD = 1


class AgentContracts extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            statusFilter: 'all',
            dateFilter: 'today',
            agentFilter: '',
            order: 'asc',
        }

        this.renderSigners = this.renderSigners.bind(this)
        this.renderAgent = this.renderAgent.bind(this)
        this.statusFilter = this.statusFilter.bind(this)
        this.dateFilter = this.dateFilter.bind(this)
        this.agentFilter = this.agentFilter.bind(this)
        this.setAgent = this.setAgent.bind(this)
        this.deleteContract = this.deleteContract.bind(this)
        this.toggleOrder = this.toggleOrder.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(fetchTilbodMulti())
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip({ html: true })
    }

    renderSigners(offer) {
        if (offer.signer_ids && offer.signer_ids.length > 0) {
            const signers = [...new Set(offer.signer_ids)]
            return signers.map((kennitala, i) =>
                <span key={`signer-${kennitala}`}>
                    {offer.people[kennitala]} ({formatKennitala(kennitala)}){i<signers.length-1? <>,<br/></>: ""} 
                </span>
            )
        } else if (offer.people) {
            const kennitala = Object.keys(offer.people)[0];
            if (!kennitala) {
                return
            }
            if (!offer.contract_change) {
                return <span style={{opacity: "30%"}} key={0}>
                    {offer.people[kennitala]} ({formatKennitala(kennitala)})
                </span>
            } else {
                return <span key={0}>
                    {offer.people[kennitala]} ({formatKennitala(kennitala)})
                </span>
            }
        }
    }

    renderAgent(offer) {
        return <>
                { this.props.agentOffers.agents.length > AGENT_THRESHOLD &&
                    <span className="agent-name" title={offer.agent_name} onClick={(e) => this.setAgent(offer.agent_name)}>{getInitials(offer.agent_name)}</span>
                }
            </>
        }

    statusFilter(value) {
        this.setState({statusFilter: value})
    }

    dateFilter(value) {
        this.setState({dateFilter: value})
    }

    agentFilter(e) {
        this.setAgent(e.target.value)
    }

    setAgent(value) {
        this.setState({agentFilter: value})
    }


    deleteContract(token) {
        Promise.resolve(this.props.dispatch(deleteTilbod(token)))
        .then(response => 
            this.props.dispatch(fetchTilbodMulti())
        )
    }

    toggleOrder() {
        if (this.state.order === 'asc') {
            this.setState({order: 'desc'})
        } else {
            this.setState({order: 'asc'})
        }
    }

    render() {

        const {agentOffers} = this.props

        if (agentOffers.isFetching) {
            return null
        }

        let offers = []

        if (agentOffers && agentOffers.offers) {
            offers = agentOffers.offers
            switch(this.state.statusFilter) {
                case 'signedUnsent':
                    offers = offers.filter(o => o.all_signed && !o.sent)
                    break;
                case 'unsigned':
                    offers = offers.filter(o => !o.all_signed && !o.paper_signing)
                    break;
                case 'paper':
                    offers = offers.filter(o => o.paper_signing)
                    break;
                case 'unsent':
                    offers = offers.filter(o => !o.sent)
                    break;
                case 'photoid':
                    offers = offers.filter(o => !o.all_ids_submitted && !o.contract_change)
                    break;
                case 'additionalDocs':
                    offers = offers.filter(o => o.contract_change || o.questionnaires)
                    break;
                }
            let today = moment.utc()
            let sevenDaysAgo = moment.utc().subtract(7, 'days')
            let fourteenDaysAgo = moment.utc().subtract(14, 'days')

            switch(this.state.dateFilter) {
                case 'today':
                    offers = offers.filter(o => moment.utc(o.created_at).isSameOrAfter(today, 'day'))
                    break;
                case '7days':
                    offers = offers.filter(o => moment.utc(o.created_at).isSameOrAfter(sevenDaysAgo, 'day'))
                    break;
                case '14days':
                    offers = offers.filter(o => moment.utc(o.created_at).isSameOrAfter(fourteenDaysAgo, 'day'))
                    break;
            }

            if (this.state.agentFilter !== '') {
                offers = offers.filter(o => o.agent_name === this.state.agentFilter)
            }

            offers = offers.filter(offer => !offer.is_subcontract).sort((a, b) => {
                // sort by created_at
                if (this.state.order === 'asc') {
                    return moment.utc(a.created_at).diff(moment.utc(b.created_at))
                } else {
                    return moment.utc(b.created_at).diff(moment.utc(a.created_at))
                }
            })
        }

        return (
            
                <div className="container-fluid xs-pt-10 xs-pb-50">
                    <div className="row">
                        <div className="col-12 text-center xs-pt-50">
                            <h3>Mínar umsóknir</h3>
                            <p className="xs-mt-20">Umsóknir í vinnslu síðustu 30 daga</p>
                        </div>
                    </div>
                    { (agentOffers && agentOffers.offers) &&
                        <div className="row">
                            <div className="col-12 col-xl-10 col-md-9 xs-pt-50">
                                <table className="table agent-contracts">
                                    <colgroup>
                                        <col width="32%" />
                                        <col width="7%" />
                                        <col width="7%" />
                                        <col width="7%" />
                                        <col width="7%" />
                                        <col width="7%" />
                                        <col width="7%" />
                                        <col width="7%" />
                                        <col width="12%" />
                                        <col width="7%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Undirritunaraðilar</th>
                                            <th><a role="button" onClick={() => this.toggleOrder()}>Dags. { this.state.order === 'asc' ? <>&darr;</> : <>&uarr;</> }</a></th>
                                            <th>Frestur</th>
                                            <th className="text-center">Undirritað</th>
                                            <th className="text-center">Gögn send</th>
                                            <th className="text-center">Skilríki</th>
                                            <th className="text-center">Pappír</th>
                                            <th className="text-center">Viðbótarskjöl</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {offers.map(offer => {
                                            let tooltipText = "";
                                            if (offer.contract_change || offer.questionnaires) {
                                                if (offer.termination) {
                                                    tooltipText += `<br /> Uppsögn`
                                                }
                                                if (offer.cancellation) {
                                                    tooltipText += `<br /> Hætt við`
                                                }
                                                if (offer.split) {
                                                    tooltipText += `<br /> Prósentuskipti`
                                                }
                                                for (let idx in offer.questionnaires) {
                                                    tooltipText += `<br /> ` + offer.questionnaires[idx];
                                                }
                                            }
                                            return (
                                                <tr key={`others-contract-line-${offer.token}`}>
                                                    <td>{this.renderAgent(offer)} {this.renderSigners(offer)}</td>
                                                    <td dangerouslySetInnerHTML={{ __html:moment.utc(offer.created_at).format('D.M<\\wbr>.YYYY')}}/>
                                                    <td dangerouslySetInnerHTML={{ __html: offer.signing_extension ? 
                                                        moment.utc(offer.created_at).add(offer.signing_extension, 'days').format("D.M<\\wbr>.YYYY")
                                                        :
                                                        moment.utc(offer.created_at).add(10, 'days').format("D.M<\\wbr>.YYYY")
                                                    }} />
                                                    <td className="text-center">{offer.all_signed && !offer.paper_signing && <div className="check-container"><span className="check check-icon small green"><SvgCheckIcon /></span></div>}{ !offer.all_signed && !offer.paper_signing &&<div className="check-container"><span className="check check-icon small red"><SvgCloseIcon /></span></div>}</td>
                                                    <td className="text-center">{offer.sent ? <div className="check-container"><span className="check check-icon small green"><SvgCheckIcon /></span></div> : <div className="check-container"><span className="check check-icon small red"><SvgCloseIcon /></span></div>}</td>
                                                    <td className="text-center">
                                                        {  offer.contract_change ? null : 
                                                            <>{offer.all_ids_submitted ? <div className="check-container"><span className="check check-icon small green"><SvgCheckIcon /></span></div> : <div className="check-container"><span className="check check-icon small red"><SvgCloseIcon /></span></div>}</>
                                                        }
                                                    </td>
                                                    <td className="text-center">{offer.paper_signing ? <div className="check-container"><span className="check check-icon small green"><SvgCheckIcon /></span></div> : null}</td>
                                                    <td className="text-center">
                                                        {tooltipText  ? 
                                                        <div className="check-container">
                                                            <span className="d-inline-block nowrap check check-icon small green" data-toggle={tooltipText === "" ? "" : "tooltip"} data-original-title={tooltipText} title={tooltipText}><SvgCheckIcon />
                                                            </span>
                                                        </div> 
                                                        : null}
                                                    </td>
                                                    <td className="text-right">
                                                        {
                                                            offer.signer_ids.length==0 && !offer.contract_change && tooltipText ? 
                                                            <a target="_blank" href={`#/fill/${offer.token}/`} className="btn btn-sm btn-primary">Aukaspurningar</a>
                                                            :
                                                            <a target="_blank" href={`#/sign/${offer.token}/`} className="btn btn-sm btn-primary">Undirskriftarsíða</a>
                                                        }
                                                        
                                                    </td>
                                                    <td className="text-right">
                                                        { ((!offer.paper_signing && !offer.all_signed) || !offer.sent) && <a target="_blank" onClick={(e) => window.confirm("Ertu viss um að þú viljir eyða þessu tilboði?") && this.deleteContract(offer.token)} className="btn btn-sm btn-danger">Eyða</a>}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 col-xl-2 col-md-3 xs-pt-50">
                                <h4>Síur</h4>

                                <a onClick={() => this.dateFilter('today')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.dateFilter==='today' ? '': 'outline-'}primary`}>Dagurinn í dag</a>
                                <a onClick={() => this.dateFilter('7days')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.dateFilter==='7days' ? '' : 'outline-'}primary`}>Síðustu 7 dagar</a>
                                <a onClick={() => this.dateFilter('14days')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.dateFilter==='14days' ? '': 'outline-'}primary`}>Síðustu 14 dagar</a>
                                <a onClick={() => this.dateFilter('all')} className={`d-block xs-mb-20 btn btn-sm btn-${this.state.dateFilter==='all' ? '': 'outline-'}primary`}>Síðustu 30 dagar</a>

                                <a onClick={() => this.statusFilter('all')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='all' ? '': 'outline-'}primary`}>Allt</a>
                                <a onClick={() => this.statusFilter('signedUnsent')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='signedUnsent' ? '': 'outline-'}primary`}>Undirritað &amp; ósent</a>
                                <a onClick={() => this.statusFilter('unsent')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='unsent' ? '': 'outline-'}primary`}>Ósent</a>
                                <a onClick={() => this.statusFilter('unsigned')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='unsigned' ? '': 'outline-'}primary`}>Óundirritað</a>
                                <a onClick={() => this.statusFilter('paper')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='paper' ? '': 'outline-'}primary`}>Pappír</a>
                                <a onClick={() => this.statusFilter('photoid')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='photoid' ? '': 'outline-'}primary`}>Skilríki vantar</a>
                                <a onClick={() => this.statusFilter('additionalDocs')} className={`d-block xs-mb-5 btn btn-sm btn-${this.state.statusFilter==='additionalDocs' ? '': 'outline-'}primary`}>Viðbótarskjöl</a>

                                { agentOffers.agents.length > AGENT_THRESHOLD &&
                                    <>
                                        <select className="custom-select xs-mt-15" id="" name="occupation" onChange={this.agentFilter} value={this.state.agentFilter}>
                                            <option value="" >Veldu ráðgjafa</option>
                                            {agentOffers.agents.map(agent => {
                                                return <option key={`agent-${agent}`} value={agent}>{agent}</option>
                                            })}
                                        </select>
                                        { this.state.agentFilter !== '' &&
                                            <div className="agent-select-clean check-container" onClick={(e) => this.setAgent('')}><span className="check check-icon small red"><SvgCloseIcon /></span></div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    }
                </div>

        )
    }
}

AgentContracts.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        agentOffers: {},
    }
    f.agentOffers = (state.agentOffers === undefined) ? {} : state.agentOffers

    return f;
}

export default connectWithStore(store, AgentContracts, mapStateToProps);
